import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBurger = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 14,
	viewBox: "0 0 20 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Menu" }), /* @__PURE__ */ _jsx("path", {
		d: "M1 7H19M1 1H19M1 13H13",
		stroke: "#475467",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgBurger;
